import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useServiceWorkerUpdate } from '../hooks/useServiceWorkerUpdate.js';
import { RrButton } from './RrButton.js';
/**
 * Overnight D4 — "A new version is available. Reload" prompt.
 *
 * Rendered once at each app's root next to `OfflineBanner`. Shows only after
 * the service-worker registration reports a waiting worker
 * (`notifyServiceWorkerUpdate`). Reload activates the new worker and the
 * plugin reloads the page once it takes control; Dismiss hides it for this
 * page load. Nothing reloads without the user asking.
 *
 * 2026-10-29 staging walk (item 8): it was a toast fixed to the bottom of the
 * viewport and sat on top of the portal's Accept button. It is now a banner
 * in the normal page flow at the very top (rendered before the app), so it
 * pushes the page down and can never cover an action. It also shows far
 * less often: an update found before the person touches the page is applied
 * at once (`applyIfUntouched`).
 */
export function RrUpdatePrompt() {
    const { available, apply, dismiss } = useServiceWorkerUpdate();
    if (!available)
        return null;
    return (_jsxs("div", { role: "status", "aria-live": "polite", "data-testid": "rr-update-prompt", className: "w-full flex flex-wrap items-center justify-center gap-3 px-4 py-2 text-sm border-b bg-[color-mix(in_srgb,var(--rr-state-info)_15%,transparent)] text-rr-state-info border-[var(--rr-state-info)]", children: [_jsx("span", { children: "A new version is available." }), _jsx(RrButton, { type: "button", variant: "primary", size: "sm", onClick: apply, children: "Reload" }), _jsx("button", { type: "button", onClick: dismiss, "aria-label": "Dismiss", className: "underline opacity-80 hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rr-teal-light rounded", children: "Not now" })] }));
}
//# sourceMappingURL=RrUpdatePrompt.js.map